import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { PackageDTO } from "./GetAllPackages";

interface PackagesData {
  pacakgeData: PackageDTO;
}
interface PackagesResponse {
  data?: PackagesData;
  error?: ApiError;
}

export const GetPackageById = async (id:string): Promise<PackagesResponse> => {
  try {
    const response = await axios.get(`/package/${id}`);
    return { data: { pacakgeData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
